// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1S6ml","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1uEr1"};